import { useRecoilState, useRecoilValue } from "recoil";
import { mapTimePanelVisibleState } from "../../store/MapTimePanelVisibleState";
import { makeStyles } from "@material-ui/core/styles";
import { TinySwitch } from "../../parts/TinySwitch";
import { selectedWeatherList } from "../../store/WeatherContentsState";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    bottom: 16,
    left:2,
    pointerEvents: 'auto'
  }
});

function ToggleContentsInfo() {
  const selectedWxList = useRecoilValue(selectedWeatherList);
  const [mapTimeVisible, setMapTimeVisible] = useRecoilState(mapTimePanelVisibleState);
  const routePointEditing = useRecoilValue(routePointEditingState);
  const classes = useStyles();

  function onClickHandler() {
    setMapTimeVisible(!mapTimeVisible);
  }

  const hidden = selectedWxList.length === 0 || routePointEditing;

  return (
    <div className={classes.root} hidden={hidden}>
      <TinySwitch checked={mapTimeVisible} onChange={onClickHandler} />
    </div>
  );
}

export default ToggleContentsInfo;